import { Image } from "common/types/images";

import { getCdnImageDetails } from "seneca-common/utils/images";

import { Content, ContentSource, ImageAssetParameters } from "../types";

export function getModuleAssets(source: Content): Array<Image> {
  return [source.image];
}

export function transformModuleAssets(
  source: ContentSource,
  assetParams: ImageAssetParameters
): Content {
  return {
    ...source,
    image: getCdnImageDetails(source.url, assetParams.default)
  };
}
